import React, { Component } from "react";

class LoanClosurePolicyContent extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="mt-4 mb-3">Loan Closure Policy</h2>
              {/* <p className="mb-3">Last Updated on December 29, 2025</p> */}
              <div className="col-12 col-md-12 row">
                <h3 className="mt-4 w-100 row justify-content-start">
                  1. Loan Recall/Cool-Off
                </h3>
                <p style={{ textAlign: "start" }}>
                  <ul>
                    <li>
                      • Timeframe: A loan can be recalled or cooled-off within
                      the first 3 days of the loan disbursement.
                    </li>
                    <li className="ml-4">
                      • <span className="fw-5">Example:</span> If a loan is
                      disbursed on April 1, 2025, it can be recalled until April
                      3, 2025.
                    </li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2">
                  Charges and Fees During Recall/Cool-Off
                </h3>
                <p style={{ textAlign: "start" }}>
                  <ul>
                    <li>
                      <span className="fw-5">• Interest Charges</span> -
                      Appropriate APR will be applied if the loan is recalled
                      within the recall period. However, currently, MoneyMonk
                      provides a Zero APR charges for loan recalls.
                    </li>
                    <li>
                      <span className="fw-5">• Processing Fee </span>- MoneyMonk
                      retains a Rs500/- processing fee, including GST, and
                      returns the rest of the processing fee, including GST, for
                      recalled loans. If the processing fee charged during
                      disbursal is lesser than or equal to Rs.500, no additional
                      processing fee discount will be provided for recalled
                      loans.{" "}
                    </li>
                    <li className="ml-4">
                      • <span className="fw-5">Example:</span> For a loan with a
                      principal of ₹20,000 and a processing fee of ₹800
                      including GST, disbursed on April 1, 2025, if recalled on
                      April 2, 2025, the customer will pay:
                      <ol className="ml-4">
                        <li>1. Principal: ₹20,000</li>
                        <li>
                          2. Processing Fee Discount Adjustment: -₹800 + ₹590 =
                          -₹210
                        </li>
                        <li>
                          3. Total Amount to Repay: ₹20,000 - ₹210 = ₹19,790
                        </li>
                      </ol>
                    </li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2">Loan Closure Restrictions</h3>
                <p style={{ textAlign: "start" }}>
                  <ol className="ml-4">
                    • Conditions Where Loan Closure is Not Allowed:
                    <ol className="ml-4">
                      <li>
                        1. If any EMI (Equated Monthly Installment) has been
                        paid.
                      </li>
                      <li>2. Partial loan recall is not permitted.</li>
                    </ol>
                  </ol>
                </p>
                <h3 className="mt-4 w-100 row justify-content-start">
                  2. Early Closure Policy:
                </h3>
                <p style={{ textAlign: "start" }}>
                  Loan can be closed by paying the full loan amount including
                  the appropriate charges. In the context of loan closure,
                  preclosure, early closure, and foreclosure all refer to the
                  same process and will incur preclosure charges.
                  <h3 className="mt-4 ">Timing for Loan Closure</h3>
                  <ol
                    style={{
                      padding: 20,
                    }}
                  >
                    <li className="mb-2">
                      • Loan can be closed after 1 day from the date of
                      disbursement.
                    </li>
                    <li className=" ml-4">
                      • Example: A loan disbursed on 1-April-2025 can be closed
                      from 3-April-2025 onwards.
                    </li>
                  </ol>
                  <h3 className="mt-4 ">Loan Closure Restrictions</h3>
                  <ol
                    style={{
                      padding: 20,
                    }}
                  >
                    <li className="mb-2">
                      • Loan closure is not allowed if only one EMI is left to
                      pay.
                    </li>
                    <li className=" ml-4">
                      • Loan closure is not allowed if any EMI is overdue. After
                      paying the overdue EMI, loan closure will be activated.
                    </li>
                  </ol>
                  <h3 className="mt-4 ">Foreclosure Charges</h3>
                  <ol
                    style={{
                      padding: 20,
                    }}
                  >
                    <li className="mb-2">
                      • Foreclosure charges of 4% of principal outstanding* +
                      GST will be charged in case Foreclosure is opted
                    </li>
                  </ol>
                </p>
                <h3 className="mt-4 w-100 row justify-content-start">
                  Representative Example
                </h3>
                <p style={{ textAlign: "start" }}>
                  To preclose or early close or foreclose a loan with a
                  principal of Rs. 10,000 at a 20% interest rate disbursed on
                  1-April-2025 and foreclosed on 5-April-2025, the total
                  repayment amount would be Rs. 10,499. This includes:
                </p>
                <h3 className="mt-3 w-100 row justify-content-start">
                  Detailed Calculation Steps
                </h3>
                <p style={{ textAlign: "start" }}>
                  <ul style={{ padding: 20 }}>
                    <li className="mb-2">• Principal: Rs. 10,000</li>
                    <li className="mb-2">• Interest Rate: 20% per annum</li>
                    <li className="mb-2">• Loan disbursed on: 1-April-2025</li>
                    <li className="mb-2">• Foreclosure date: 5-April-2025</li>
                    <li className="mb-2">• Interest Charges:</li>
                    <li className="mb-2 ml-4">
                      {" "}
                      Interest for 5 days: 10,000 × 20% × 5 / 365 = 27
                    </li>
                    <li className="mb-2">• Preclosure Charges:</li>
                    <li className="mb-2 ml-4">
                      {" "}
                      Preclosure Charge=10,000 × 4% = 400
                    </li>
                    <li className="mb-2">• GST on Preclosure Charges:</li>
                    <li className="mb-2 ml-4">
                      • GST (18% on Preclosure Charges): GST = 400 × 18% = 72
                    </li>
                    <li className="mb-2">• Total Repayment Amount:</li>
                    <li className=" ml-4">
                      {" "}
                      • Total Repayment = Principal + Interest + Preclosure
                      Charges + GST Total Repayment = 10,000 + 27 + 400 + 72 =
                      10,499
                    </li>
                  </ul>
                  Thus, the borrower needs to pay Rs. 10,499 to close the loan.
                </p>
                <h3 className="mt-3 row justify-content-start">
                  Loan part-prepayment, EMI part-prepayment, Loan Part-payment,
                  EMI Part-payment is not allowed. Customer can choose to pay
                  EMIs in full. *round to the nearest rupee
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default LoanClosurePolicyContent;
